import React from 'react';
import { Mail, Linkedin, Instagram } from 'lucide-react';

const Footer = ({ onOpenTerms, onOpenPrivacy }) => {
  return (
    <footer className="bg-gray-50 border-t border-gray-200">
      {/* Contact Section */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="text-center mb-8">
          <p className="text-gray-600 mb-4">Feel free to reach us at:</p>
          <a
            href="mailto:care@decimalskincare.com"
            className="inline-flex items-center gap-2 text-gray-900 hover:text-brand-600 transition-colors font-medium"
          >
            <Mail className="w-5 h-5" />
            care@decimalskincare.com
          </a>
        </div>

        {/* Footer Links */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 py-12 border-t border-gray-200">
          {/* Support */}
          <div>
            <h3 className="text-sm font-semibold text-gray-400 uppercase tracking-wider mb-4">
              SUPPORT
            </h3>
            <ul className="space-y-3">
              <li>
                <a
                  href="#"
                  className="text-gray-600 hover:text-brand-600 transition-colors"
                >
                  Contact Us
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-gray-600 hover:text-brand-600 transition-colors"
                >
                  Delete Account
                </a>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 className="text-sm font-semibold text-gray-400 uppercase tracking-wider mb-4">
              COMPANY
            </h3>
            <ul className="space-y-3">
              <li>
                <a
                  href="mailto:careers@decimalskincare.com"
                  className="text-gray-600 hover:text-brand-600 transition-colors"
                >
                  Careers
                </a>
              </li>
              <li>
                <a
                  href="mailto:careers@decimalskincare.com"
                  className="text-brand-600 hover:text-brand-700 transition-colors"
                >
                  careers@decimalskincare.com
                </a>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-sm font-semibold text-gray-400 uppercase tracking-wider mb-4">
              LEGAL
            </h3>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={onOpenTerms}
                  className="text-gray-600 hover:text-brand-600 transition-colors"
                  data-testid="terms-link"
                >
                  Terms & Conditions
                </button>
              </li>
              <li>
                <button
                  onClick={onOpenPrivacy}
                  className="text-gray-600 hover:text-brand-600 transition-colors"
                  data-testid="privacy-link"
                >
                  Privacy Policy
                </button>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Footer */}
        <div className="flex flex-col md:flex-row justify-between items-center pt-8 border-t border-gray-200">
          <p className="text-gray-600 text-sm mb-4 md:mb-0">.decimal © 2025</p>
          
          {/* Social Links */}
          <div className="flex items-center gap-4">
            <a
              href="https://www.linkedin.com/company/decimal-skincare/"
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 rounded-full bg-gray-900 flex items-center justify-center hover:bg-brand-600 transition-colors"
              aria-label="LinkedIn"
            >
              <Linkedin className="w-5 h-5 text-white" />
            </a>
            <a
              href="https://www.instagram.com/decimalskincare"
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 rounded-full bg-gray-900 flex items-center justify-center hover:bg-brand-600 transition-colors"
              aria-label="Instagram"
            >
              <Instagram className="w-5 h-5 text-white" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;